/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_Last_TitleInputs */



/**
* | output |
* | --- |
* | "Last event" |
*
* @param {Image_Export_Preview_Last_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_last_title = /** @type {((inputs?: Image_Export_Preview_Last_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Last_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dernier evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Letztes Ereignis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ultimo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Последнее событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Último evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上一次活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最後のイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंतिम कार्यक्रम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Último evento")
	return /** @type {LocalizedString} */ ("Last event")
});